import {GuideStep} from '@blesk-frontend/api';
import {cn, Image, StaticImage} from '@blesk-frontend/ui';

interface CollectionImageStackProps {
  count?: number;
  imgStep: GuideStep | null;
}

export const CollectionImageStack = ({count, imgStep}: CollectionImageStackProps) => (
  <div className="relative aspect-[1.5] w-full max-w-[300px] select-none">
    <div className="absolute top-0 left-0 h-[84%] w-[89.33%] rounded-md border bg-bg-secondary p-2 transition-all group-hover:bg-bg-secondary-hover">
      <div className="relative size-full rounded-sm bg-border-primary" />
    </div>
    <div className="absolute top-[8%] left-[5.33%] h-[84%] w-[89.33%] rounded-md border bg-bg-secondary p-2 transition-all group-hover:bg-bg-secondary-hover">
      <div className="relative size-full rounded-sm bg-border-primary" />
    </div>
    <div className="absolute top-[16%] left-[10.67%] h-[84%] w-[89.33%] rounded-md border bg-bg-secondary p-2 transition-all group-hover:bg-bg-secondary-hover">
      {imgStep ? (
        <StaticImage
          src={
            imgStep.payload.src.cropped ||
            imgStep.payload.src.edited ||
            imgStep.payload.src.original
          }
          alt={imgStep.payload.element.text || ''}
        />
      ) : (
        <div className="relative flex size-full items-center justify-center rounded-sm bg-border-primary text-text-contrast">
          <Image className="h-[36%] min-h-[48px] w-[24%] min-w-[48px]" />
        </div>
      )}
    </div>
    <div
      className={cn(
        'absolute right-[5.33%] bottom-[8%] box-border flex min-h-6 min-w-6 items-center justify-center rounded-sm border border-transparent bg-bg-secondary p-1.5 text-text-secondary tabular-nums',
        'text-paragraph-xs',
        count !== undefined && 'border border-border-primary p-1',
      )}
    >
      {count !== undefined ? count : <div className="size-3 rounded-xs bg-border-primary" />}
    </div>
  </div>
);
